module.exports = __webpack_public_path__ + "static/media/cart-product-3.c041a4a1.png";